module.exports = __webpack_public_path__ + "img/banner@2x.82fd056f.jpg";